import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { UiModule } from '@freelancer/ui';
import { InvitationRedirectAlertComponent } from './invitation-redirect-alert.component';

@NgModule({
  imports: [CommonModule, UiModule],
  exports: [InvitationRedirectAlertComponent],
  declarations: [InvitationRedirectAlertComponent],
})
export class InvitationRedirectAlertModule {}
